"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaloAbilityHandler = exports.HaloActorAbilityFactory = exports.HaloAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class HaloAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Halo;
        this.__typeName = "Halo";
    }
}
exports.HaloAbilityArgs = HaloAbilityArgs;
let HaloActorAbilityFactory = class HaloActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Halo", "Self", 4);
    }
};
HaloActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Halo")
], HaloActorAbilityFactory);
exports.HaloActorAbilityFactory = HaloActorAbilityFactory;
let HaloAbilityHandler = class HaloAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.HasteEffectArgs(1),
                        new core_1.LinkedEventHandlerEffectArgs("Effect On Hit", "Applies slow on hit", false, container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttack", {
                            applyTo: "attacked",
                            onHitOnly: true,
                            effects: [{
                                    duration: Duration_1.Duration.Turns(2),
                                    effect: new core_1.SlowEffectArgs(1),
                                    percentChance: 100
                                }]
                        }))
                    ], false),
                });
            }
        });
    }
};
HaloAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Halo)
], HaloAbilityHandler);
exports.HaloAbilityHandler = HaloAbilityHandler;
